import type { Tour } from '@/types/tour';
import { currentRoomId } from '@/core/state';
import { findRoomLocation } from '@/core/tour-utils';

// Info-Overlay rechts unten: Raumname, Meta, Beschreibung, Tags.
// Subscribed direkt auf currentRoomId und rendert den Inhalt neu.

export class InfoOverlay {
  private el: HTMLElement;

  constructor(parent: HTMLElement, private tour: Tour) {
    this.el = document.createElement('aside');
    this.el.className = 'info-overlay';
    this.el.setAttribute('role', 'complementary');
    this.el.setAttribute('aria-live', 'polite');
    parent.appendChild(this.el);

    currentRoomId.subscribe((id) => this.render(id));
    this.render(currentRoomId.get());
  }

  private render(roomId: string): void {
    const loc = findRoomLocation(this.tour, roomId);
    if (!loc) {
      this.el.innerHTML = '';
      return;
    }
    const { room } = loc;
    this.el.innerHTML = `
      <header class="info-overlay__head">
        <h2 class="info-overlay__name">${escapeHtml(room.name)}</h2>
        <p class="info-overlay__meta">${escapeHtml(room.meta)}</p>
      </header>
      <p class="info-overlay__desc">${escapeHtml(room.description)}</p>
      <ul class="info-overlay__tags">
        ${room.tags.map((t) => `<li>${escapeHtml(t)}</li>`).join('')}
      </ul>
    `;
  }
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
